// extracted by mini-css-extract-plugin
export default {"notification":"notification_notification__lV2O8","notificationActions":"notification_notificationActions__gUNuG"};